// Global Instructions Rule Applied!

import {
  SetTopicsAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  AddTopicAction,
  UpdateTopicRecordAction,
  RemoveTopicAction,
  TopicsPaginatedResponse,
  FilterValue,
  SortConfig
} from '../../interfaces/distribution_lists.ts'
import { CommsTopicGridModel } from '../../data_models/comms_topic_grid_model.ts'
import {
  SET_TOPICS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  ADD_TOPIC,
  UPDATE_TOPIC_RECORD,
  REMOVE_TOPIC
} from './constants.ts'

export const setTopics = ({ response }: { response: TopicsPaginatedResponse }): SetTopicsAction => ({
  type: SET_TOPICS,
  payload: { response }
})

export const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

export const setActiveSorting = ({ sorting }: { sorting: SortConfig[] }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

export const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const addTopic = ({ topic }: { topic: CommsTopicGridModel }): AddTopicAction => ({
  type: ADD_TOPIC,
  payload: { topic }
})

export const updateTopicRecord = ({
  topicId,
  updates
}: {
  topicId: string
  updates: Record<string, any>
}): UpdateTopicRecordAction => ({
  type: UPDATE_TOPIC_RECORD,
  payload: { topicId, updates }
})

export const removeTopic = ({ topicId }: { topicId: string }): RemoveTopicAction => ({
  type: REMOVE_TOPIC,
  payload: { topicId }
})
